import { render, staticRenderFns } from "./CommonLanding.vue?vue&type=template&id=0877f9d2&scoped=true"
import script from "./CommonLanding.vue?vue&type=script&lang=js"
export * from "./CommonLanding.vue?vue&type=script&lang=js"
import style0 from "./CommonLanding.vue?vue&type=style&index=0&id=0877f9d2&prod&scoped=true&lang=css"
import style1 from "./CommonLanding.vue?vue&type=style&index=1&id=0877f9d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0877f9d2",
  null
  
)

export default component.exports